import { getCurrentInstance } from 'vue'
/**
 * get a field from current vue instance proxy, if it exists
 * @param {string} fieldname
 * @returns any
 */
export function getInstanceField(fieldname: string): any {
  const currentInstance = getCurrentInstance()?.proxy

  if (!currentInstance) {
    return undefined
  }
  const fieldEntry = (currentInstance as any)[fieldname]

  return fieldEntry
}
